export const REPORT_PRINT_CSS = `
  .report-print-document {
    background: #eef2f7;
    color: #1a1f2e;
    font-family: Inter, system-ui, sans-serif;
    padding: 24px;
  }
  .report-print-page {
    background: #fff;
    box-shadow: 0 18px 50px rgba(15, 23, 42, .14);
    display: flex;
    flex-direction: column;
    height: 297mm;
    margin: 0 auto 24px;
    overflow: hidden;
    width: 210mm;
  }
  .report-print-measure-document {
    background: #fff;
    left: -10000px;
    padding: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    visibility: hidden;
    width: 210mm;
    z-index: -1;
  }
  .report-print-measure-document .report-print-page {
    box-shadow: none;
    margin: 0;
  }
  .report-print-measure-document [data-report-measure-sections-page="true"] {
    height: auto;
    min-height: 297mm;
    overflow: visible;
  }
  .report-print-document,
  .report-print-page,
  .report-print-header,
  .report-print-metrics {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .report-print-header {
    border-bottom: 1px solid #dde3ea;
    padding: 18mm 16mm 10mm;
  }
  .report-print-brand {
    align-items: center;
    color: #5c6878;
    display: flex;
    font-size: 9px;
    font-weight: 800;
    justify-content: space-between;
    letter-spacing: .12em;
    text-transform: uppercase;
  }
  .report-print-brand-mark {
    align-items: center;
    display: inline-flex;
    gap: 6px;
    min-width: 0;
  }
  .report-print-brand-logo {
    display: block;
    max-height: 40px;
    max-width: 128px;
    object-fit: contain;
  }
  .report-print-title-row {
    align-items: flex-end;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin-top: 20px;
  }
  .report-print-title-row h1 {
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1;
    margin: 0 0 4px;
  }
  .report-print-title-row p {
    color: #5c6878;
    font-size: 12px;
    letter-spacing: .03em;
    margin: 0;
    text-transform: uppercase;
  }
  .report-print-title-row p:empty {
    display: none;
  }
  .report-print-date {
    color: #2c4a7a;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    text-align: right;
  }
  .report-print-date strong {
    display: block;
    font-size: 22px;
  }
  .report-print-date span {
    color: #5c6878;
    display: block;
    font-size: 11px;
    letter-spacing: .06em;
    text-transform: uppercase;
  }
  .report-print-metrics {
    background: #2e3848;
  }
  .report-print-metric-row {
    display: grid;
    border-bottom: 1px solid rgba(255, 255, 255, .10);
  }
  .report-print-metric-row-volume {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .report-print-metric-row-volume.report-print-metric-row-count-1 {
    grid-template-columns: minmax(0, 1fr);
  }
  .report-print-metric-row-total {
    grid-template-columns: 1fr 1fr 1.35fr;
    border-bottom: 0;
  }
  .report-print-metric-row-total.report-print-metric-row-count-2 {
    grid-template-columns: minmax(0, 1.35fr) minmax(0, .65fr);
  }
  .report-print-metric-row-legacy {
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    border-bottom: 0;
  }
  .report-print-metric {
    min-width: 0;
    border-right: 1px solid rgba(255, 255, 255, .08);
    padding: 12px 16px;
    text-align: right;
  }
  .report-print-metric-row .report-print-metric:last-child {
    border-right: 0;
  }
  .report-print-metric span {
    color: rgba(255, 255, 255, .38);
    display: block;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: .12em;
    text-transform: uppercase;
  }
  .report-print-metric strong {
    color: rgba(255, 255, 255, .92);
    display: block;
    font: 800 24px ui-monospace, SFMono-Regular, Menlo, monospace;
    margin-top: 4px;
  }
  .report-print-metric-highlight strong {
    color: #9ec9a0;
  }
  .report-print-page-context {
    color: #5c6878;
    display: flex;
    font-size: 9px;
    font-weight: 800;
    justify-content: space-between;
    letter-spacing: .1em;
    padding: 14mm 16mm 0;
    text-transform: uppercase;
  }
  .report-print-page-context + .report-print-body {
    padding-top: 7mm;
  }
  .report-print-body {
    flex: 1;
    padding: 14mm 16mm;
  }
  .report-print-section {
    break-inside: avoid;
    margin-bottom: 14px;
  }
  .report-print-section-head {
    background: #eef1f8;
    border: 1px solid #dde3ea;
    border-bottom: 0;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 10px 12px;
  }
  .report-print-section-head strong {
    color: #2c4a7a;
    display: block;
    font-size: 13px;
  }
  .report-print-section-head span {
    color: #5c6878;
    display: block;
    font-size: 11px;
    margin-top: 2px;
  }
  .report-print-section-head b {
    align-self: center;
    background: #fff;
    border: 1px solid #bcc8dc;
    border-radius: 4px;
    color: #2c4a7a;
    font: 800 12px ui-monospace, SFMono-Regular, Menlo, monospace;
    padding: 4px 10px;
    white-space: nowrap;
  }
  .report-print-section-summary {
    background: #fff;
    border: 1px solid #bcc8dc;
    display: grid;
    font: 800 10px ui-monospace, SFMono-Regular, Menlo, monospace;
    gap: 14px;
    grid-template-columns: minmax(0, 1fr) auto;
    margin-top: 8px;
    padding: 6px 8px;
  }
  .report-print-summary-volume {
    color: #2c4a7a;
    line-height: 1.28;
    white-space: normal;
  }
  .report-print-summary-money {
    color: #3d6b41;
    text-align: right;
    white-space: nowrap;
  }
  .report-print-table {
    border: 1px solid #dde3ea;
    border-collapse: collapse;
    margin: 0;
    table-layout: fixed;
    width: 100%;
  }
  .report-print-table th {
    background: #f3f5f8;
    border-bottom: 2px solid #dde3ea;
    color: #5c6878;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: .1em;
    padding: 8px 10px;
    text-align: left;
    text-transform: uppercase;
  }
  .report-print-table td {
    border-bottom: 1px solid #f3f5f8;
    color: #2e3848;
    font-size: 11px;
    padding: 9px 10px;
    vertical-align: middle;
  }
  .report-print-table-cell {
    overflow-wrap: anywhere;
  }
  .report-print-row-compact td {
    height: 37px;
    padding-bottom: 6px;
    padding-top: 6px;
  }
  .report-print-row-normal td {
    height: 43px;
    padding-bottom: 9px;
    padding-top: 9px;
  }
  .report-print-row-wrapped td {
    height: 50px;
    line-height: 1.35;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .report-print-table .report-print-cell-align-right {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-weight: 800;
    text-align: right;
  }
  .report-print-table .report-print-cell-nowrap {
    white-space: nowrap;
  }
  .report-print-table-cell--numeric,
  .report-print-metric-value {
    white-space: nowrap;
  }
  .report-print-cell-secondary {
    color: #9aaab8;
    display: block;
    font: 700 9px ui-monospace, SFMono-Regular, Menlo, monospace;
    margin-top: 2px;
  }
  .report-print-cell-emphasis {
    color: #3d6b41;
    font-weight: 900;
  }
  .report-print-row-highlight td {
    background: #eff6ff;
    color: #1d4ed8;
  }
  .report-print-row-highlight .report-print-cell-emphasis,
  .report-print-row-highlight .report-print-cell-secondary {
    color: #1d4ed8;
  }
  .report-print-row-muted td {
    color: #6b7280;
  }
  .report-print-footer {
    background: #f3f5f8;
    border-top: 1px solid #dde3ea;
    color: #9aaab8;
    font-size: 10px;
    line-height: 1.7;
    margin-top: auto;
    padding: 12px 16mm;
  }
  .report-print-footer strong,
  .report-print-footer span {
    display: block;
  }
  .report-frame-root > .report-preview-pane {
    box-sizing: border-box;
    height: 100%;
  }
  .report-preview-pane {
    background: #eef2f7;
    min-height: 100%;
    overflow: auto;
    padding: 24px;
    scrollbar-color: rgba(46, 56, 72, .32) rgba(46, 56, 72, .08);
    scrollbar-width: thin;
  }
  .report-frame-root {
    height: 100vh;
    overflow: hidden;
  }
  .report-frame-root > .report-preview-pane {
    box-sizing: border-box;
    height: 100%;
    min-height: 0;
  }
  .report-preview-pane::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  .report-preview-pane::-webkit-scrollbar-track {
    background: rgba(46, 56, 72, .08);
    border-radius: 999px;
  }
  .report-preview-pane::-webkit-scrollbar-thumb {
    background: rgba(46, 56, 72, .32);
    border-radius: 999px;
  }
  .report-preview-pane::-webkit-scrollbar-thumb:hover {
    background: rgba(46, 56, 72, .46);
  }
  .report-preview-scale {
    margin: 0 auto;
    min-height: calc(297mm * .42);
    position: relative;
    width: calc(210mm * .42);
  }
  .report-preview-scale > .report-print-document {
    position: absolute;
    transform: scale(.42);
    transform-origin: top left;
    width: 210mm;
  }
  .report-preview-pane .report-print-document {
    background: transparent;
    padding: 0;
  }
  @page { size: A4; margin: 0; }
  @media print {
    html,
    body {
      overflow: visible !important;
    }
    body { background: #fff; margin: 0; }
    .report-frame-root {
      height: auto;
      overflow: visible;
    }
    .report-preview-pane {
      background: #fff;
      overflow: visible;
      padding: 0;
    }
    .report-preview-scale {
      margin: 0;
      min-height: 0;
      position: static;
      width: auto;
    }
    .report-print-preview-document,
    .report-print-preview-document * {
      display: none !important;
    }
    .report-print-measure-document,
    .report-print-measure-document * {
      display: none !important;
      visibility: hidden !important;
    }
    .report-print-source-document {
      background: #fff;
      padding: 0;
      position: static;
      width: 100%;
    }
    .report-preview-scale > .report-print-source-document {
      transform: none;
      transform-origin: top left;
      width: 100%;
    }
    .report-print-page {
      box-shadow: none;
      break-after: page;
      height: 297mm;
      margin: 0;
      overflow: hidden;
      page-break-after: always;
      width: 210mm;
    }
    .report-print-page:last-child {
      break-after: auto;
      page-break-after: auto;
    }
  }
`;
